export default __webpack_public_path__ + "e75140777340f4c6f97540214c6b0bf2.jpg";